module.exports = __webpack_public_path__ + "static/media/download.244ba780.svg";